'use client';

import React from 'react';
import { MotionDiv } from '@/components/motion';

interface PolicyPageLayoutProps {
  title: string;
  lastUpdated?: string;
  children: React.ReactNode;
}

export default function PolicyPageLayout({ 
  title, 
  lastUpdated,
  children 
}: PolicyPageLayoutProps) {
  return (
    <MotionDiv 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-lg"
    >
      <div className="mb-8">
        <h1 className="text-2xl font-bold mb-2">{title}</h1>
        {lastUpdated && (
          <p className="text-sm text-gray-500">
            Última actualización: {lastUpdated}
          </p>
        )}
      </div>
      
      <div className="prose prose-lg max-w-none">
        {children}
      </div>
    </MotionDiv>
  );
} 